import { Nilable } from "@shared/utils";

export interface IPruebaInternaDTO {
    combo_id: number;
    group_id: number;
    research_id: number;
}

export class PruebaInternaDTO {
    public combo_id = 0;
    public group_id = 0;
    public research_id = 0;

    constructor(json: Nilable<Partial<IPruebaInternaDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPruebaInternaDTO>) {
        if (json.group_id) {
            this.group_id = json.group_id;
        }
        if (json.research_id) {
            this.research_id = json.research_id;
        }
        if (json.combo_id) {
            this.combo_id = json.combo_id;
        }
    }

    public toJSON(): IPruebaInternaDTO {
        return {
            group_id: this.group_id,
            research_id: this.research_id,
            combo_id: this.combo_id
        };
    }
}
